import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { TesterConfig } from "./types";

export const TESTER_PREFS_KEY = "ORCA_ORDER_FLOW_TESTER_PREFS";

interface TesterPrefsState {
  /** Last-used configuration; null means "use defaults from mobile config". */
  config: TesterConfig | null;
  lastTargetId: string | null;
  setConfig: (config: TesterConfig) => void;
  setLastTarget: (targetId: string) => void;
  reset: () => void;
}

/**
 * Persists only test configuration (test customer/supplier ids, parts, rider
 * placeholders, invoice defaults). Never store tokens or production data here.
 */
export const useTesterPrefs = create<TesterPrefsState>()(
  persist(
    (set) => ({
      config: null,
      lastTargetId: null,
      setConfig: (config) => set({ config }),
      setLastTarget: (lastTargetId) => set({ lastTargetId }),
      reset: () => set({ config: null, lastTargetId: null }),
    }),
    {
      name: TESTER_PREFS_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ config: state.config, lastTargetId: state.lastTargetId }),
    }
  )
);
